import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { AmbulanceCardSearchParams } from 'app/integration/document/ambulance-card/services/ambulance-card-search-params';
import { Observable } from 'rxjs';
import { SearchHttpParams, SearchResult } from '@heda/core-util';
import { map } from 'rxjs/operators';
import { AmbulanceCard } from 'app/integration/document/ambulance-card/services/ambulance-card';

@Injectable()
export class AmbulanceCardService {
  constructor(private http: HttpClient) {}

  protected baseUrl = `${environment.estnhsApi}/digilugu/ambulance-card`;

  public search(params: AmbulanceCardSearchParams): Observable<SearchResult<AmbulanceCard>> {
    return this.http
      .get(`${this.baseUrl}`, { params: SearchHttpParams.build(params) })
      .pipe(map((resp) => resp as SearchResult<AmbulanceCard>));
  }
}
